import { createContext } from 'react'

// #898 item 2 — carries the SERVER-resolved venue time zone from the form
// container (EventNew / EventEdit, where useCrossZoneConfirm computes it) down
// to the on-form Summary, which is rendered propless deep in the uniforms
// field tree and so cannot receive it by prop. The value is the SAME
// authoritative IANA zone the cross-zone confirm shows (null until a venue or
// community selection has driven the resolve query — the no-selection footgun
// stays handled upstream), so the Summary's zone is provably what the event
// will be stored in, surfaced during form-filling rather than only at submit.
export const ResolvedZoneContext = createContext<string | null>(null)
